
import { Component, Vue, Prop } from 'vue-property-decorator';
import { getNetboxColorAndTranslationForStatus } from '@/components/shared/helpers';
import { getFontColorBasedOnBackground } from '@/helpers';
@Component
export default class NetboxStatusChip extends Vue {
  // selection custom fields (e.g. delivery_status) come from netbox as { value, label }
  @Prop() private status!: string | { value: string; label: string } | null;
  private getFontColor = getFontColorBasedOnBackground;
  private get colorAndTranslation(): { color: string; text: string } {
    if (this.status == null) {
      return { color: 'grey', text: 'Neznan' };
    }
    if (typeof this.status === 'object') {
      return getNetboxColorAndTranslationForStatus(this.status.value);
    }
    return getNetboxColorAndTranslationForStatus(this.status);
  }
}
